import type React from 'react';

interface FantasyScoreProps {
  value?: number | null;
}

export const FantasyScore: React.FC<FantasyScoreProps> = ({ value }) => {
  if (value == null) {
    return (
      <div className="rounded bg-gray-200 px-2 py-0.5 text-sm font-semibold leading-none text-gray-700">
        -
      </div>
    );
  }

  // Determine color scheme based on value ranges
  const getColorClasses = () => {
    if (value > 8) {
      return 'bg-blue-100 text-blue-900';
    }
    if (value >= 4.5) {
      return 'bg-green-100 text-green-900';
    }
    if (value >= 3.5) {
      return 'bg-gray-100 text-gray-900';
    }
    if (value >= 1.5) {
      return 'bg-orange-100 text-orange-900';
    }
    return 'bg-red-100 text-red-900';
  };

  return (
    <div className={`rounded px-2 py-0.5 text-sm font-semibold leading-none ${getColorClasses()}`}>
      {value.toFixed(1)}
    </div>
  );
};
